var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,{"currentPage":_vm.currentPage,"currentPageData":_vm.currentPageData,"setPageSize":_vm.setPageSizeAndEmit,"setCurrentPage":_vm.setCurrentPageAndEmit,"total":_vm.count,"pageSizes":_vm.pageSizes,"pageSize":_vm.pageSize})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }